import { Modal } from "rsuite";

interface ReviewDisputeImageProps {
  show: boolean;
  onClose: () => void;
  imageUrl?: string;
}

export default function ReviewDisputeImage({
  show,
  onClose,
  imageUrl,
}: ReviewDisputeImageProps) {
  return (
    <Modal backdrop="static" show={show} onHide={onClose} size="md">
      <Modal.Header>
        <Modal.Title>Uploaded Image</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {imageUrl ? (
          <div
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            <img
              src={imageUrl}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 8,
                objectFit: "fill",
              }}
              alt="dispute"
            />
          </div>
        ) : (
          <p>No image available.</p>
        )}
      </Modal.Body>
    </Modal>
  );
}
